import script from "./ActivityTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__